import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';


@Component({
  selector: 'app-student-library',
  templateUrl: './student-library.component.html',
  styleUrls: ['./student-library.component.scss']
})
export class StudentLibraryComponent implements OnInit, OnChanges {
  @Input() dynamicStudentUserId: any;
  @Input() studentPartnerId;

  studentLibraryStudentId: any;
  partnerId;
  isRenderVideo = false;
  isRenderMinuteVideo = false;
  showMinuteVideo;
  localData;
  constructor(
    private loginInfoProvider: LoginInfoProvider
  ) { }

  onTabClick(event: MatTabChangeEvent) {
    this.isRenderVideo = event.tab.textLabel === 'Program Videos';
    this.isRenderMinuteVideo = event.tab.textLabel === 'Envision Minute Videos'
  }

  ngOnInit() {
    this.partnerId = this.loginInfoProvider.partnerId;
    this.studentLibraryStudentId = this.dynamicStudentUserId;
    this.studentPartnerId = this.studentPartnerId || this.partnerId;
    this.localData = JSON.parse(localStorage.getItem('loginUserData'))
    if (this.localData.role.toLowerCase() === 'student' || this.localData.role.toLowerCase() === 'parent') {
      this.showMinuteVideo = this.localData.showMinuteVideo
    } else {
      this.showMinuteVideo = JSON.parse(localStorage.getItem('showMinuteVideo'));
    }
   
  }

  ngOnChanges() {
    this.studentLibraryStudentId = this.dynamicStudentUserId;
    this.studentPartnerId = this.studentPartnerId || this.partnerId;
  }
}
